import script from "./UploadTask.vue?vue&type=script&setup=true&lang=js"
export * from "./UploadTask.vue?vue&type=script&setup=true&lang=js"

import "./UploadTask.vue?vue&type=style&index=0&id=19f43880&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-19f43880"]])

export default __exports__